export default __webpack_public_path__ + "static/media/On demand order.cb0f2bca.jpg";